import { supplierFeature } from './supplier.reducer';

export const {
  selectSuppliers,
  selectIsLoading,
  selectError,
  selectSupplierState,
} = supplierFeature;
